import { useEffect, useState } from "react";

function useUserIP() {
  const [ip, setIp] = useState(null);

  useEffect(() => {
    fetch("https://api.ipify.org?format=json")
      .then((res) => res.json())
      .then((data) => setIp(data.ip))
      .catch((err) => console.error("Failed to fetch IP:", err));
  }, []);

  return ip;
}

export default useUserIP;